import { useTranslation } from "react-i18next";
import SearchInput from "../search-input";
import { useDocsFilterStore } from "@/features/docs/stores";
import DocsTopicFilter from "@/features/docs/components/docs-topic-filter";

const DocumentationPageHeader = () => {
  const { searchValue, setSearchValue } = useDocsFilterStore();
  const { t } = useTranslation();
  return (
    <div className="flex-1 flex items-center justify-between gap-4 w-full">
      <h1 className="lg:text-lg">{t("titles.dashboard.documentation.list")}</h1>
      <div className="flex items-center gap-2 flex-1 justify-end">
        <SearchInput
          value={searchValue ?? ""}
          onChange={setSearchValue}
          placeholder={t("modules.docs.keys.search_placeholder")}
          className="max-w-72 hidden lg:flex"
        />
        <div className="hidden lg:block">
          <DocsTopicFilter />
        </div>
      </div>
    </div>
  );
};

export default DocumentationPageHeader;
